import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev';
import * as Sentry from '@sentry/react';

import { isTestEnvironment } from '@spotify/confidence-core-react';

import { loadTrackJS } from './apis/ConsentManagement';

const IS_PRODUCTION = process.env.NODE_ENV === 'production';
const IS_E2E_TEST = isTestEnvironment();
const IS_LOCALHOST = window?.location.hostname.startsWith('localhost');

if (IS_PRODUCTION && !IS_E2E_TEST && !IS_LOCALHOST) {
  loadTrackJS();
}

Sentry.init({
  dsn: 'https://e429b0654e22474f81655df4103dd4bb@o22381.ingest.sentry.io/4504633286131712',
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 0.0025,
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
  enabled: IS_PRODUCTION,
  environment: process.env.NODE_ENV,
});

if (!IS_PRODUCTION) {
  // show apollo errors in dev
  loadDevMessages();
  loadErrorMessages();

  // enable MSW
  try {
    if (window?.localStorage.getItem('use-msw') === 'true') {
      import('./mocks/browser').then(({ worker }) => {
        worker.start();
      });
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);
  }
}
